import { render } from "./BaseGDPRTemplate.vue?vue&type=template&id=111b4236"
import script from "./BaseGDPRTemplate.vue?vue&type=script&lang=js"
export * from "./BaseGDPRTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__